<template>
  <div
    class="text-center m-0 my-sm-5 mx-sm-auto p-5 card card-body text-center text-muted pending"
    style="max-width: 600px;"
  >
    <p class="text-accent mb-5 pending-text">{{ title }}</p>
    <div class="logo__wrapper">
      <img
        class="text-center mx-auto img__removepointer"
        v-if="parameters != null"
        :src="parameters.logo"
        :alt="parameters.nome"
        height="50"
      />
    </div>

    <!-- <p v-if="parameters !== null">{{parameters.nome}}</p> -->
  </div>
</template>
<script>
import ErrorMessages from '../models/ErrorMessages';
export default {
  props: ['title', 'parameters', 'datetime'],
  computed: {
    details: function () {
      if (this && this.title === ErrorMessages.surveyAlredyDone)
        return ErrorMessages.surveyAlredyDoneDetails + this.datetime;
      else return ErrorMessages.surveyNotFoundDetails;
    },
  },
};
</script>

<style>
@media (max-width: 900px) {
  .pending-text {
    margin-top: 50px;
    font-size: 18px;
  }
  .pending {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    margin: 0 !important;
    padding: 0 !important;
  }
  .logo__wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
